module.exports = __webpack_public_path__ + "static/media/info_block_2.21c42aaf.png";